import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import NumberSpinner from "../../NumberSpinner/NumberSpinner"
import CurrencyInput from "../../CurrencyInput/CurrencyInput"
import RateBuilderErrors from "../RateBuilderErrors"
import AddButtonNew from "../../AddButton/AddButtonNew";

class RateBuilderGuestTypes extends React.Component {

  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'guest_types',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="guest_types">
        <div className="panel panel-default" style={{ marginBottom: 0 }}>
          <div className="panel-heading flexed add-button-pannel">
            <div className="col-md-6" >
              <h3 className="panel-title">{I18n.t('guest_types')}<span className="ss-help help" title={I18n.t('products_helper_text')}></span>   </h3>
            </div>
            <div className="col-md-6 content-right flexed">
              <AddButtonNew
                model="GuestType"
                column="name"
                ids={this.props.guest_types ? this.props.guest_types.map((guest_type) => { return guest_type.id; }) : null} 
                onAdd={this.props.onAddGuestType} text={I18n.t('add')} 
                buttonClasses="btn btn-secondary" 
                new_button={false}
                generalPosition="left"
              />
            </div>
          </div>
          <div className="panel-body container">
            <div className={"products "}>
              {this.renderGuestTypes()}
            </div>
          </div>
        </div>
      </div>  
    )
  }

  renderGuestTypes() {
    var self = this;
    var guest_types = self.props.guest_types.map(function (guest_type) {
      var rate_guest_type = self.getRateGuestType(guest_type);
      return (
        <div className="row guest-type" key={guest_type.id}>
          <div className="col-md-3 name-wrapper">
            <div className="form-group">
              <label>{I18n.t('guest_type')}</label>
              <div>{guest_type.name} ({self.renderAgeRange(guest_type)})</div>
            </div>
          </div>
          <div className="col-md-3">
            <label>{I18n.t('guests_included')}</label>
            <NumberSpinner 
              onChange={self.onChange} 
              name={guest_type.id + '|guests_included'} 
              min={0} 
              value={rate_guest_type ? (rate_guest_type.guests_included || '') : ''}
              hasError={self.renderFieldClasses('guests_included', null, guest_type.id)}  />
            {self.renderFieldErrors('guests_included', guest_type.id)}
          </div>
          <div className="col-md-3">
            <label>{I18n.t('amount_per_additional_guest')}</label>
            <CurrencyInput 
              onChange={self.onChange} 
              onChangeEventType={true} 
              name={guest_type.id + '|additional_guest_price_amount'} 
              value={rate_guest_type ? (rate_guest_type.additional_guest_price_amount || '') : ''}
              className={self.renderFieldClasses('additional_guest_price_amount', 'form-control', guest_type.id)}
            />
            {self.renderFieldErrors('additional_guest_price_amount', guest_type.id)}
          </div>
          <div className="col-md-3">
            <label>{I18n.t('frequency')}</label>
            <div className={self.renderFieldClasses('frequency', 'input-group', guest_type.id)}>
              <select 
                onChange={self.onChange} 
                name={guest_type.id + '|frequency'} 
                value={rate_guest_type && rate_guest_type.frequency ? rate_guest_type.frequency : ''} 
                className="form-control">
                <option value="">{I18n.t('please_select')}</option>
                <option value="one_time">{I18n.t('one_time')}</option>
                <option value="recurring">{I18n.t('recurring')}</option>
              </select>
            </div>
            {self.renderFieldErrors('frequency', guest_type.id)}
          </div>
          <div className="col flexed content-right">
            <button type="button" className={"btn btn-secondary btn-sm remove-product-btn"} onClick={self.props.onRemoveGuestType.bind(self, guest_type.id)}>
              {I18n.t('remove')}
            </button>
          </div>
          {self.props.guest_types.length > 1  ? <hr /> : null}
        </div>
      )
    })

    return (
      <div className="guest-types-form">
        {guest_types && guest_types.length ? guest_types : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
      </div>
    )
  }

  renderAgeRange(guest_type) {
    if (guest_type.maximum_age == null || typeof guest_type.maximum_age == 'undefined') {
      return (
        <span>{guest_type.minimum_age}+</span>
      )
    } else {
      return (
        <span>{guest_type.minimum_age} &ndash; {guest_type.maximum_age}</span>
      )
    }
  }

  returnErrors(guest_type_id) {
    var errors = RateBuilderErrors.guest_types(this.props.errors)
    var returnErrors = null
    for (var i = 0; i < errors.length; i++) {
      if (Object.keys(errors[i])[0] === guest_type_id) {
        returnErrors = Object.values(errors[i])[0]
      }
    }
    return returnErrors
  }

  renderFieldErrors(field, guest_type_id) {
    var guest_type_errors = this.returnErrors(guest_type_id)
    if (guest_type_errors && guest_type_errors[field]) {
      var idx = 0;
      var errors = guest_type_errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;

      });
      return (
      <div className="help-block">
          {errors}
        </div>
      )
    }
  }

  renderFieldClasses(field, classnames, guest_type_id) {
    var errors = this.returnErrors(guest_type_id)
    var classname = classnames || 'form-control';
    if (errors && Object.keys(errors).length && errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  /******************
  * Change handlers *
  *******************/

  onChange(event) {
    if (event && event.target) {

      var guest_type_id = event.target.name.split('|')[0]
      var name = event.target.name.split('|')[1]

      if (this.props.rate_guest_types && this.props.rate_guest_types.length) {
        var found_match = false
        for (var i = 0, ilen = this.props.rate_guest_types.length; i < ilen; i++) {
          if (this.props.rate_guest_types[i].guest_type_id == guest_type_id) {
            this.props.rate_guest_types[i][name] = event.target.value
            found_match = true
            break
          }
        }
        if (!found_match) {
          var rate_guest_type = {
            guest_type_id: guest_type_id
          }
          rate_guest_type[name] = event.target.value
          this.props.rate_guest_types.push(rate_guest_type)
        }
      } else {
        var rate_guest_type = {
          guest_type_id: guest_type_id
        }
        rate_guest_type[name] = event.target.value
        this.props.rate_guest_types.push(rate_guest_type)
      }

      if (typeof this.props.onChange == 'function') {
        this.props.onChange({
          target: {
            name: 'rate_guest_types',
            value: this.props.rate_guest_types
          }
        })
      }
    }
  }

  getRateGuestType(guest_type) {
    if (this.props.rate_guest_types && this.props.rate_guest_types.length) {
      for (var i = 0, ilen = this.props.rate_guest_types.length; i < ilen; i++) {
        if (this.props.rate_guest_types[i].guest_type_id == guest_type.id) {
          return this.props.rate_guest_types[i];
        }
      }
    }

    return null
  }
}

export default RateBuilderGuestTypes